import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=9b1f1d38&scoped=true&"
var script = {}
import style0 from "./Score.vue?vue&type=style&index=0&id=9b1f1d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1f1d38",
  null
  
)

component.options.__file = "Score.vue"
export default component.exports